import classNames from "classnames";

import useVenue from "../../hooks/useVenue";
import Framed from "../Framed";

import * as styles from "./styles.module.scss";

type FramedTitleProps = {
  text: string;
  light?: boolean;
  withSpacing?: boolean;
};

const FramedTitle = ({
  text,
  light = false,
  withSpacing = false,
}: FramedTitleProps) => {
  const { isBexley, isEltham } = useVenue();
  const frameStyle = isBexley ? "birch" : "gold";

  return (
    <div
      className={classNames(styles.container, {
        [styles.withSpacing]: withSpacing,
        [styles.bexley]: isBexley,
        [styles.eltham]: isEltham,
      })}
    >
      <Framed style={frameStyle}>
        <div className={styles.innerContainer}>
          <div
            className={classNames(styles.letterBoard, {
              [styles.light]: light,
            })}
          />
          <h1 className={classNames(styles.h1, { [styles.light]: light })}>
            {text}
          </h1>
        </div>
      </Framed>
    </div>
  );
};

export default FramedTitle;
